var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { width, space, compose } from 'styled-system';
import { buttonStyles } from '../Button';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';
const variations = {
    fill: css `
    &:hover {
      text-decoration: none;
    }

    ${buttonStyles}
  `,
    subtle: css `
    ${buttonStyles}

    &:hover {
      text-decoration: none;
      background-color: ${getPaletteColor('background.tint')};
    }
  `,
    link: css `
    cursor: pointer;
    text-decoration: none;
    color: ${getPaletteColor('base')};

    &:hover {
      color: ${getPaletteColor('dark')};
      text-decoration: underline;
    }
  `,
    outline: css `
    &:hover {
      text-decoration: none;
    }

    ${buttonStyles}
  `,
    plain: css `
    ${buttonStyles}

    &:hover {
      text-decoration: none;
      background-color: ${getPaletteColor('background.base')};
    }
  `,
    white: css `
    ${buttonStyles}

    &:hover {
      text-decoration: none;
      background-color: ${getPaletteColor('background.base')};
    }
  `,
    lightFill: css `
    ${buttonStyles}
    ${(props) => {
        return props.disabled
            ? `
        background-color: ${getPaletteColor('background.base')(props)};
        color: ${getPaletteColor('text.light')(props)};`
            : '';
    }}
  `,
    input: css `
    ${buttonStyles}
    text-align: center;
    ${(props) => {
        return props.disabled
            ? `
        background-color: ${getPaletteColor('background.base')(props)};
        color: ${getPaletteColor('text.light')(props)};`
            : '';
    }}
  `,
};
const propTypes = {
    color: deprecatedColorValue(),
    disabled: PropTypes.bool,
    variation: PropTypes.oneOf(Object.keys(variations)),
};
const Link = styled.a.attrs((_a) => {
    var { color, disabled, href, target, onClick } = _a, props = __rest(_a, ["color", "disabled", "href", "target", "onClick"]);
    return (Object.assign({ color: disabled ? 'text.light' : color, disabled, href: !disabled ? href : undefined, rel: target === '_blank' ? 'noopener' : null, target, onClick: !disabled ? onClick : () => { } }, props));
}) `
  ${applyVariations('Link', variations)}

  ${(props) => props.disabled &&
    `
    cursor: default;

    &:hover {
      text-decoration: none;
    }
  `}

  ${(props) => compose(space, width)(props)}
`;
Link.displayName = 'Link';
Link.defaultProps = {
    color: 'primary',
    variation: 'link',
    size: 'medium',
};
Link.propTypes = propTypes;
export default Link;
//# sourceMappingURL=Link.js.map